export default {"src":"/_next/static/media/b2.32b68c14.svg","height":65,"width":159,"blurWidth":0,"blurHeight":0};